export const enum AuditLogResourceType {
  CheckRun = 'check-run',
  CheckRunList = 'check-run-list',
  File = 'file',
  CoverageCategoryOnGroup = 'coverage-category-on-group',
  CRNotificationRecipient = 'cr-notification-recipient',
  CRReportOnGroup = 'cr-report-on-group',
  Group = 'group',
  GroupSchedule = 'group-schedule',
  Holiday = 'holiday',
  HolidayOverride = 'holiday-override',
  JWTToken = 'jwt-token',
  NotificationRecipient = 'notification-recipient',
  OneTimeCode = 'one-time-code',
  User = 'user'
}
